module.exports = "/assets/data/31631fff27c896db63096c0006aa8da7-TA21.data.json";